/**
 * @generated SignedSource<<697a253c7c1f7174dbc9377eeba53eb2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ClassificationLevelSource = "AUTO" | "CONTENT" | "NONE" | "ORGANIZATION" | "SPACE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useContentClassification_content$data = {
  readonly classificationLevelDetails: {
    readonly canManageSpaceSettings: boolean;
    readonly classificationControlSetting: string | null;
    readonly classificationLevel?: {
      readonly color: string | null;
      readonly description: string | null;
      readonly guideline: string | null;
      readonly guidelineADF: string | null;
      readonly id: string;
      readonly name: string;
      readonly status: string;
    } | null;
    readonly classificationLevelV2?: {
      readonly color: string | null;
      readonly description: string | null;
      readonly guideline: string | null;
      readonly guidelineADF: string | null;
      readonly id: string;
      readonly name: string;
      readonly status: string;
    };
    readonly featureEnabled: boolean;
    readonly isReclassificationPermitted: boolean;
    readonly source: ClassificationLevelSource | null;
    readonly userOverrideSetting: string | null;
  } | null;
  readonly id: string | null;
  readonly " $fragmentType": "useContentClassification_content";
};
export type useContentClassification_content$key = {
  readonly " $data"?: useContentClassification_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useContentClassification_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  (v0/*: any*/),
  {
    "kind": "ScalarField",
    "name": "guideline"
  },
  {
    "kind": "ScalarField",
    "name": "guidelineADF"
  },
  {
    "kind": "ScalarField",
    "name": "description"
  },
  {
    "kind": "ScalarField",
    "name": "color"
  },
  {
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "kind": "ScalarField",
    "name": "status"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "useClassificationLevelV2"
    }
  ],
  "kind": "Fragment",
  "name": "useContentClassification_content",
  "selections": [
    (v0/*: any*/),
    {
      "concreteType": "ClassificationLevelDetails",
      "kind": "LinkedField",
      "name": "classificationLevelDetails",
      "plural": false,
      "selections": [
        {
          "condition": "useClassificationLevelV2",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "concreteType": "ContentDataClassificationLevel",
              "kind": "LinkedField",
              "name": "classificationLevel",
              "plural": false,
              "selections": (v1/*: any*/)
            }
          ]
        },
        {
          "condition": "useClassificationLevelV2",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "ContentDataClassificationLevel",
              "kind": "LinkedField",
              "name": "classificationLevelV2",
              "plural": false,
              "selections": (v1/*: any*/)
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "featureEnabled"
        },
        {
          "kind": "ScalarField",
          "name": "source"
        },
        {
          "kind": "ScalarField",
          "name": "isReclassificationPermitted"
        },
        {
          "kind": "ScalarField",
          "name": "canManageSpaceSettings"
        },
        {
          "kind": "ScalarField",
          "name": "classificationControlSetting"
        },
        {
          "kind": "ScalarField",
          "name": "userOverrideSetting"
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "8caefc9ae5cd8ffee2bc5ea1aa65be77";

export default node;
